module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHUAAAAECAYAAACwenDYAAAAiUlEQVRIS92UQQqAIBBF5x+jblTXCByPpELXqBtVl4iJgVokBgMtBF25eF8/81CklAYRmYmIAEzOuVX3+bJymrOytbjWOyLGuBFRd0vcmbkvSbVymrWytbjWO+ZSD2Z+BL/cZgI+ucLAfp9pvdvKtd4RIYQRgH6/p4g47/1SeqlWTrNWthbXescLF0g9oG+NilgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/image/huidiandian@2x.png
// module id = Q1BF
// module chunks = 19